import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Select from '../../../../../components/Select/index';
import { FILING_PRIORITY } from '../../../../../services/constant/constant';

class FilingRequestForm extends Component {
    componentWillUnmount() {
        let { updateFileRequestData } = this.props;
        updateFileRequestData({
            filingPriorityType: '',
            amount: '',
            isCommission: '',
            isInitialPurchase: '',
            isInstitutionalExemption: '',
            requestTransactionType: '',
            requestAccountType: ''
        });
    }
    handleInputChange = event => {
        let {
            filingRequestData,
            isEditable,
            updateFileRequestData
        } = this.props;
        if (isEditable) {
            const target = event.target;
            const value =
                target.type === 'checkbox' ? target.checked : target.value;
            const name = target.name;

            let tmpSelected = _.extend({}, filingRequestData);
            tmpSelected[name] = value;
            updateFileRequestData(tmpSelected);
        }
    };

    handleSelectChange = (name, value) => {
        let { filingRequestData, updateFileRequestData } = this.props;
        let tmpSelected = _.extend({}, filingRequestData);
        if (value !== null) {
            tmpSelected[name] = value[name];
        } else {
            tmpSelected[name] = '';
        }
        updateFileRequestData(tmpSelected);
    };

    render() {
        let { filingRequestData, isEditable, formRef } = this.props;

        return (
            <form ref={formRef}>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Is Priority</label>
                        <Select
                            name="filingPriorityType"
                            labelKey="label"
                            valueKey="filingPriorityType"
                            options={[
                                {
                                    label: 'Yes - With exemptions',
                                    filingPriorityType:
                                        FILING_PRIORITY.PRIORITY_WITH_EXEMPTIONS
                                },
                                {
                                    label: 'Yes - Just file ASAP',
                                    filingPriorityType:
                                        FILING_PRIORITY.FILE_WITH_PRIORITY
                                },
                                {
                                    label: 'No - Takes 2-3 days',
                                    filingPriorityType:
                                        FILING_PRIORITY.NON_PRIORITY
                                }
                            ]}
                            selectedValue={filingRequestData.filingPriorityType}
                            onChange={this.handleSelectChange}
                            disabled={!isEditable}
                            required={true}
                        />
                    </div>
                </div>
                {filingRequestData.filingPriorityType === 1 && (
                    <div>
                        <div className="row">
                            <div className="form-group col-md-12">
                                <label>Amount</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="amount"
                                    value={filingRequestData.amount}
                                    onChange={this.handleInputChange}
                                    contentEditable={isEditable}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-md-12">
                                <label>Commission?</label>
                                <Select
                                    name="isCommission"
                                    labelKey="label"
                                    valueKey="isCommission"
                                    options={[
                                        { label: 'Yes', isCommission: true },
                                        { label: 'No', isCommission: false }
                                    ]}
                                    selectedValue={
                                        filingRequestData.isCommission
                                    }
                                    onChange={this.handleSelectChange}
                                    disabled={!isEditable}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-md-12">
                                <label>Is Initial Purchase?</label>
                                <Select
                                    name="isInitialPurchase"
                                    labelKey="label"
                                    valueKey="isInitialPurchase"
                                    options={[
                                        {
                                            label: 'Yes',
                                            isInitialPurchase: true
                                        },
                                        {
                                            label: 'No',
                                            isInitialPurchase: false
                                        }
                                    ]}
                                    selectedValue={
                                        filingRequestData.isInitialPurchase
                                    }
                                    onChange={this.handleSelectChange}
                                    disabled={!isEditable}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-md-12">
                                <label>Is Institutional Exemption?</label>
                                <Select
                                    name="isInstitutionalExemption"
                                    labelKey="label"
                                    valueKey="isInstitutionalExemption"
                                    options={[
                                        {
                                            label: 'Yes',
                                            isInstitutionalExemption: true
                                        },
                                        {
                                            label: 'No',
                                            isInstitutionalExemption: false
                                        }
                                    ]}
                                    selectedValue={
                                        filingRequestData.isInstitutionalExemption
                                    }
                                    onChange={this.handleSelectChange}
                                    disabled={!isEditable}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-md-12">
                                <label>Transaction Type</label>
                                <Select
                                    name="requestTransactionType"
                                    labelKey="label"
                                    valueKey="requestTransactionType"
                                    options={[
                                        {
                                            label: 'Redemption',
                                            requestTransactionType: 5
                                        },
                                        {
                                            label: 'Purchase',
                                            requestTransactionType: 6
                                        },
                                        {
                                            label: 'Regular Exchange',
                                            requestTransactionType: 1
                                        },
                                        {
                                            label: 'Share Class Exchange',
                                            requestTransactionType: 2
                                        },
                                        {
                                            label: 'Rollover',
                                            requestTransactionType: 3
                                        },
                                        {
                                            label: 'Fund Merger',
                                            requestTransactionType: 4
                                        }
                                    ]}
                                    selectedValue={
                                        filingRequestData.requestTransactionType
                                    }
                                    onChange={this.handleSelectChange}
                                    disabled={!isEditable}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-md-12">
                                <label>Account Type</label>
                                <Select
                                    name="requestAccountType"
                                    labelKey="label"
                                    valueKey="requestAccountType"
                                    options={[
                                        {
                                            label: 'Individual',
                                            requestAccountType: 1
                                        },
                                        {
                                            label: 'Joint Tenants',
                                            requestAccountType: 2
                                        },
                                        {
                                            label: 'Individual IRA',
                                            requestAccountType: 3
                                        },
                                        {
                                            label: 'Corporation',
                                            requestAccountType: 4
                                        },
                                        {
                                            label: 'Broker/Dealer',
                                            requestAccountType: 5
                                        },
                                        {
                                            label: 'Profit Sharing Plan',
                                            requestAccountType: 6
                                        },
                                        {
                                            label: 'Pension Plan',
                                            requestAccountType: 7
                                        },
                                        {
                                            label: 'Financial Institution',
                                            requestAccountType: 8
                                        }
                                    ]}
                                    selectedValue={
                                        filingRequestData.requestAccountType
                                    }
                                    onChange={this.handleSelectChange}
                                    disabled={!isEditable}
                                    required={true}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </form>
        );
    }
}

FilingRequestForm.propTypes = {
    filingRequestData: PropTypes.object.isRequired,
    updateFileRequestData: PropTypes.func.isRequired,
    isEditable: PropTypes.func.bool
};

FilingRequestForm.defaultProps = {
    isEditable: true
};
export default FilingRequestForm;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ClientDetails/components/FilingRequestForm.js